export const CAR_VALUATION_LOADING = 'CAR_VALUATION_LOADING';
export const CAR_VALUATION_SUCCESS = 'CAR_VALUATION_SUCCESS';
export const CAR_VALUATION_ERROR = 'CAR_VALUATION_ERROR';

export interface ICarValuationInitialType {
    loading: boolean;
    data: any;
    error: boolean;
}
